export const StatsStore = [
  {
    num: "15",
    suffix: "+",
    label: "Years in Operation",
    desc: "Established 2009, continuously expanding capacity.",
  },
  {
    num: "80",
    suffix: "+",
    label: "Engineers & Machinists",
    desc: "Certified team operating across two shifts, 24/5.",
  },
  {
    num: "30",
    suffix: "+",
    label: "CNC Machines",
    desc: "3, 4 & 5-axis mills, lathes, and EDM on-site.",
  },
  {
    num: "20",
    suffix: "+",
    label: "Countries Served",
    desc: "Exporting precision components to clients worldwide.",
  },
];